<template>
  <div>
    <img
      src="/img/logo.png"
      alt="Kreator"
      height="120"
    />
    <h1>Witaj w kreatorze zaproszeń</h1>
    <p>
      Poniżej możesz zobaczyć wszystkie zaproszenia dostępne do samodzielnej
      personalizacji przy pomocy kreatora.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Headline',
};
</script>

<style lang="less" scoped>
p {
  max-width: 500px;
  margin: 15px auto 30px;
  color: rgb(146, 146, 146);
}
h1 {
  margin-top: 30px;
}
</style>
